module.exports = "pegasus/assets/themelp1/basic/103.png";